import { useFormik } from "formik";

const ReusableInput = ({ label, type, value, placeholder }) => {
  const formik = useFormik({
    initialValues: {
      input: value || "",
    },
    validate: (values) => {
      const errors = {};

      if (type === "email") {
        const email = values.input;
        const testEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
          email
        );
        if (!email) {
          errors.input = "Please enter your email address";
        } else if (!testEmail) {
          errors.input = "Please enter a valid email address";
        }
      }

      if (type === "password") {
        const password = values.input;
        const passwordPattern =
          /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,20}$/.test(
            password
          );

        if (!password) {
          errors.input = "Please enter a password";
        } else if (values.input.length < 8 || values.input.length > 20) {
          errors.input = "Please enter a password between 8 and 20 characters";
        } else if (!passwordPattern) {
          errors.input =
            "Password must contain one digit, one lowercase letter, one uppercase letter, and one special character";
        }
      }

      return errors;
    },
    onSubmit: (values) => {
      console.log(formik.values);
      // Handle form submission
    },
  });
  // console.log("Form values", formik.values);

  return (
    // <div className="">
    <div className=" mt-7">
      <label
        className="block text-xs sm:text-sm md:text-base font-normal "
        htmlFor="input"
      >
        {label} (required)
      </label>
      <input
        type={type === "password" ? "password" : "text"}
        name="input"
        value={formik.values.input}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        className={`w-full px-4 py-2 pr-10 text-xs md:text-sm border ${
          formik.errors.input ? "border-red-500" : "border-gray-300"
        } rounded-md focus:outline-none focus:ring-2 bg-white shadow-md`}
        placeholder={placeholder || `e.g. ${label.toLowerCase()}`}
      />
      {formik.errors.input && formik.touched.input && (
        <span className="text-red-500 text-xs mt-1">{formik.errors.input}</span>
      )}
    </div>
    // {/* </div> */}
  );
};

export default ReusableInput;

// import { useFormik } from 'formik';

// const ReusableInput = ({ label, type, value }) => {
//     const formik = useFormik({
//         initialValues: {
//             input: value || '',
//         },
//         validate: (values) => {
//             const errors = {};

//             if (type === 'email' && !values.input.includes('@')) {
//                 errors.input = 'Invalid email';
//             }

//             if (type === 'password') {
//                 const password = values.input;
//                 const hasEightLetters = password.length >= 8;
//                 const hasSpecialCharacter = /[!@#$%^&*()]/.test(password);
//                 const isAlphanumeric = /^(?=.*[0-9])(?=.*[a-zA-Z])/.test(password);

//                 if (!hasEightLetters) {
//                     errors.input = 'Must contain at least 8 letters';
//                 } else if (!hasSpecialCharacter) {
//                     errors.input = 'Must contain a special character';
//                 } else if (!isAlphanumeric) {
//                     errors.input = 'Must be alphanumeric';
//                 }
//             }

//             return errors;
//         },
//         onSubmit: (values) => {
//             // Handle form submission
//         },
//     });

//     return (
//         <div className="relative">
//             <div className="relative">
//                 <label className="block text-xs sm:text-sm md:text-base font-normal mb-2" htmlFor="input">
//                     {label} (required)
//                 </label>
//                 <input
//                     type={type === 'password' ? 'password' : 'text'}
//                     name="input"
//                     value={formik.values.input}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     className={`w-full px-4 py-2 pr-10 text-xs md:text-sm border ${formik.errors.input ? 'border-red-500' : 'border-gray-300'
//                         } rounded-md focus:outline-none focus:ring-2 bg-white shadow-md`}
//                     placeholder={`e.g. ${label.toLowerCase()}`}
//                 />
//                 {formik.errors.input && formik.touched.input && (
//                     <div className="text-red-500 text-xs mt-1">{formik.errors.input}</div>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default ReusableInput;
